import { useState } from "react";
import { X } from "lucide-react";
import { fileUrl } from "@/lib/api";

export const Gallery = ({ images = [] }) => {
  const [active, setActive] = useState(null);
  if (!images.length) return <p className="text-sm text-zinc-500">No photos yet.</p>;

  return (
    <>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4" data-testid="gallery-grid">
        {images.map((img) => (
          <button key={img.id} onClick={() => setActive(img)}
            className="group aspect-square overflow-hidden rounded-lg border border-[#2A2A32] bg-[#0A0A0C]"
            data-testid={`gallery-thumb-${img.id}`}>
            <img src={fileUrl(img.path)} alt="Gallery" loading="lazy"
              className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
          </button>
        ))}
      </div>

      {active && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4" onClick={() => setActive(null)} data-testid="gallery-lightbox">
          <button className="absolute right-5 top-5 text-white" onClick={() => setActive(null)} data-testid="lightbox-close"><X size={32} /></button>
          <img src={fileUrl(active.path)} alt="Gallery large" className="max-h-[90vh] max-w-full rounded-lg object-contain" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </>
  );
};
